/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Plan_Change_CurrentInputs */

const fr_membership_plan_change_current = /** @type {(inputs: Membership_Plan_Change_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formule actuelle`)
};

/**

* @param {Membership_Plan_Change_CurrentInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_plan_change_current = /** @type {((inputs?: Membership_Plan_Change_CurrentInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Plan_Change_CurrentInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_plan_change_current(inputs)
});